module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/cooking-pot-74ad6c4f6df03e159d16a7379557a9bb.svg";